import clone from 'fast-clone';
import { getNodeId } from '../store/actionHandlers/common/adapterActions';

export default class NodeCustomText {
  constructor({ nodeCustomText = () => null }) {
    this._nodeCustomText = nodeCustomText;
  }

  get key() {
    return 'nodeCustomText';
  }

  prepareTreeState(treeState) {
    treeState.nodeCustomText = {};
  }

  handleDidAddModels(treeState, models, { adapter }) {
    const textToAdd = models.reduce((hash, model) => {
      const id = getNodeId(adapter, model);

      const customText = this._nodeCustomText(model);
      if (customText) {
        hash[id] = customText;
      }

      return hash;
    }, {});

    const nodeIds = Object.keys(textToAdd);
    if (nodeIds.length) {
      const nodeCustomText = clone(treeState.nodeCustomText);

      for (const nodeId of nodeIds) {
        nodeCustomText[nodeId] = textToAdd[nodeId];
      }

      treeState.nodeCustomText = nodeCustomText;
    }
  }

  handleDidChangeModels(treeState, changedModels, { adapter }) {
    const changes = {};

    for (const model of changedModels) {
      const id = getNodeId(adapter, model);

      const customText = this._nodeCustomText(model) || null;
      const oldCustomText = treeState.nodeCustomText[id] || null;

      if (customText !== oldCustomText) {
        changes[id] = customText;
      }
    }

    const nodeIds = Object.keys(changes);
    if (nodeIds.length) {
      const nodeCustomText = clone(treeState.nodeCustomText);

      for (const nodeId of nodeIds) {
        const customText = changes[nodeId];

        if (customText) {
          nodeCustomText[nodeId] = customText;
        } else {
          delete nodeCustomText[nodeId];
        }
      }

      treeState.nodeCustomText = nodeCustomText;
    }
  }

  handleDidRemoveModels(treeState, modelIdsSet) {
    const idsToRemove = Array.from(modelIdsSet).filter(
      id => !!treeState.nodeCustomText[id],
    );

    if (idsToRemove.length) {
      const nodeCustomText = clone(treeState.nodeCustomText);
      idsToRemove.forEach(id => delete nodeCustomText[id]);
      treeState.nodeCustomText = nodeCustomText;
    }
  }

  getNodeCustomText(treeState, nodeId) {
    return treeState.nodeCustomText[nodeId] || null;
  }
}
